import { render, staticRenderFns } from "./SessionsNewGroups.vue?vue&type=template&id=091a1c40&scoped=true&"
import script from "./SessionsNewGroups.vue?vue&type=script&lang=js&"
export * from "./SessionsNewGroups.vue?vue&type=script&lang=js&"
import style0 from "./SessionsNewGroups.vue?vue&type=style&index=0&id=091a1c40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091a1c40",
  null
  
)

export default component.exports